import React from "react";
import { getColumnsData } from "./ServiceContractColumns";
import OTAPagination from "../OTAPagination";
import { getReportsForServiceContactAuditByDateRangeWithPagination } from "../../services/Dashboard";
const ContractReportsGrid = (props) => {
  const columns = getColumnsData();
  
  return (
    <OTAPagination
      checkboxSelection={true}
      columns={columns}
      endpointFn={getReportsForServiceContactAuditByDateRangeWithPagination}
      queryName={"ContractAudit"}
      filterMode="server"
      getRowId={(row) => row.auditId}
      defaultExport={true}
      {...props}
    />
  );
};

export default ContractReportsGrid;
